import { useSelector } from 'react-redux';
import { RootState } from '~/store';
import { useGetBankAccountsQuery } from '~/store/apis/endpoints/onboardingApi/onboarding.api';
import { useBankInformationFooter } from '../components/BankInformation/BankInformationFooterContext';

interface ManualAccountFormState {
  isManualAccountFormShown: boolean;
  canGoBackToSearch: boolean;
}

// The Stepper renders the bank step's header and body separately, so both read this to agree on the view
const useManualAccountForm = (): ManualAccountFormState => {
  const {
    overview: { clientId },
    form: { accountNumber },
  } = useSelector((state: RootState) => state.loanOffer);
  const { showAddNewAccount } = useBankInformationFooter();
  const { isError: fetchingBankAccountsFailed } = useGetBankAccountsQuery(
    { clientId },
    {
      skip: !clientId,
    }
  );

  return {
    isManualAccountFormShown:
      showAddNewAccount &&
      (accountNumber !== null || fetchingBankAccountsFailed),
    // The bank search needs the bank accounts call, so without it manual entry is the only option
    canGoBackToSearch: !fetchingBankAccountsFailed,
  };
};

export default useManualAccountForm;
